import * as COURIER_SCHEMA from './couriers'
import * as STORE_PROFILE_SCHEMA from './storeProfiles'
import * as STORE_SCHEMA from './stores'
import * as PRODUCT_DETAIL_SCHEMA from './productDetails'
import * as PRODUCT_SCHEMA from './products'
import * as STORE_PRODUCT_SCHEMA from './storeProducts'
import * as ORDER_SCHEMA from './orders'
import * as ORDER_TRANSACTIONS_SCHEMA from './orderTransactions'
import * as USERS_COURIER_SCHEMA from './usersCourier'
import * as USERS_SCHEMA from './users'
import * as USERS_STORE_SCHEMA from './usersStore'
import * as USERS_SUPPORT_SCHEMA from './usersSupport'
import * as USER_ADDRESSES_SCHEMA from './userAddresses'
import * as ENTRIES_SCHEMA from './entries'
import * as ORDER_MESSAGES_SCHEMA from './orderMessages'
import * as RELATIONSHIPS_SCHEMA from './relationships'

export const ENTRIES = {
    fields: ENTRIES_SCHEMA.ENTRIES
}
// -----------------------------------------------------------------------------
export const COURIERS = {
    fields: COURIER_SCHEMA.COURIERS,
    internalContact: COURIER_SCHEMA.INTERNAL_CONTACT,
    externalContact: COURIER_SCHEMA.EXTERNAL_CONTACT,
    feeRules: COURIER_SCHEMA.FEE_RULES,
    routeRules: COURIER_SCHEMA.ROUTE_RULES,
    days: COURIER_SCHEMA.DAYS
}
// -----------------------------------------------------------------------------
export const ORDERS = {
    fields: ORDER_SCHEMA.ORDERS,
    deliveryAddress: ORDER_SCHEMA.DELIVERY_ADDRESS,
    items: ORDER_SCHEMA.ITEMS,
    orderStep: ORDER_SCHEMA.ORDER_STEP,
    courierFeeRules: ORDER_SCHEMA.COURIER_FEE_RULES,
    adminFeeRules: ORDER_SCHEMA.ADMIN_FEE_RULES,
    deliveryAdminFeeRules: ORDER_SCHEMA.DELIVERY_ADMIN_FEE_RULES
}
// -----------------------------------------------------------------------------
export const ORDER_TRANSACTIONS = {
    fields: ORDER_TRANSACTIONS_SCHEMA.ORDER_TRANSACTIONS,
    card: ORDER_TRANSACTIONS_SCHEMA.CARD,
    refund: ORDER_TRANSACTIONS_SCHEMA.REFUND,
    billing: ORDER_TRANSACTIONS_SCHEMA.BILLING,
    paymentProcessor: ORDER_TRANSACTIONS_SCHEMA.PAYMENT_PROCESSOR,
    fraud: ORDER_TRANSACTIONS_SCHEMA.FRAUD
}
// -----------------------------------------------------------------------------
export const ORDER_MESSAGES = {
    fields: ORDER_MESSAGES_SCHEMA.ORDER_MESSAGES
}
// -----------------------------------------------------------------------------
export const PRODUCTS = {
    fields: PRODUCT_SCHEMA.PRODUCTS
}
// -----------------------------------------------------------------------------
export const PRODUCT_DETAILS = {
    fields: PRODUCT_DETAIL_SCHEMA.PRODUCT_DETAILS,
    photos: PRODUCT_DETAIL_SCHEMA.PHOTOS
}
// -----------------------------------------------------------------------------
export const STORES = {
    fields: STORE_SCHEMA.STORES,
    storeEmployees: STORE_SCHEMA.STORE_EMPLOYEES
}
// -----------------------------------------------------------------------------
export const STORE_PROFILES = {
    fields: STORE_PROFILE_SCHEMA.STORE_PROFILES,
    address: STORE_PROFILE_SCHEMA.ADDRESS,
    hours: STORE_PROFILE_SCHEMA.HOURS,
    adminFeeRules: STORE_PROFILE_SCHEMA.ADMIN_FEE_RULES,
    deliveryFeeRules: STORE_PROFILE_SCHEMA.DELIVERY_ADMIN_FEE_RULES
}
// -----------------------------------------------------------------------------
export const STORE_PRODUCTS = {
    fields: STORE_PRODUCT_SCHEMA.STORE_PRODUCTS,
    variants: STORE_PRODUCT_SCHEMA.VARIANTS
}
// -----------------------------------------------------------------------------
export const USERS_COURIER = {
    fields: USERS_COURIER_SCHEMA.USERS_COURIER
}
// -----------------------------------------------------------------------------
export const USERS = {
    fields: USERS_SCHEMA.USERS
}
// -----------------------------------------------------------------------------
export const USER_ADDRESSES = {
    fields: USER_ADDRESSES_SCHEMA.USER_ADDRESSES
}
// -----------------------------------------------------------------------------
export const USERS_STORE = {
    fields: USERS_STORE_SCHEMA.USERS_STORE
}
// -----------------------------------------------------------------------------
export const USERS_SUPPORT = {
    fields: USERS_SUPPORT_SCHEMA.USERS_SUPPORT
}
// -----------------------------------------------------------------------------
export const RELATIONSHIPS = {
    rel_couriers_orders: RELATIONSHIPS_SCHEMA.REL_COURIERS_ORDERS,
    rel_couriers_orders_by_action: RELATIONSHIPS_SCHEMA.REL_COURIERS_ORDERS_BY_ACTION,
    rel_users_orders: RELATIONSHIPS_SCHEMA.REL_USERS_ORDERS,
    rel_global_orders_by_payment_status: RELATIONSHIPS_SCHEMA.REL_GLOBAL_ORDERS_BY_PAYMENT_STATUS,
    rel_stores_orders: RELATIONSHIPS_SCHEMA.REL_STORES_ORDERS,
    rel_stores_orders_by_action: RELATIONSHIPS_SCHEMA.REL_STORES_ORDERS_BY_ACTION,
    rel_stores_orders_by_eod: RELATIONSHIPS_SCHEMA.REL_STORES_ORDERS_BY_EOD,
    rel_stores_products_by_category: RELATIONSHIPS_SCHEMA.REL_STORES_PRODUCTS_BY_CATEGORY,
    rel_stores_product_sheets: RELATIONSHIPS_SCHEMA.REL_STORES_PRODUCT_SHEETS,
    rel_global_product_sheets_by_status: RELATIONSHIPS_SCHEMA.REL_GLOBAL_PRODUCT_SHEETS_BY_STATUS,
    rel_greenlineProducts_store: RELATIONSHIPS_SCHEMA.REL_GREENLINE_PRODUCTS_STORE
}
